import React from 'react';
import { useTranslation } from 'react-i18next';
import { DistanceUnitFormatter } from 'components/modules/master/formatters';
import { DEFAULT_DISTANCE_UNIT } from 'utils/localization/types';
import { useDistance } from 'hooks/useDistance';
import DescriptionListItem from 'components/v2/DescriptionListItem';
export const OrderDistance = ({ distance, routingType, routingConfiguration, fromUnit = 'm', toUnit = DEFAULT_DISTANCE_UNIT, }) => {
    const { t } = useTranslation();
    const { hasDistance, isPcMiler, routerName } = useDistance({
        distance,
        routingType,
        routingConfiguration,
    });
    if (!hasDistance) {
        return null;
    }
    const versionLabel = isPcMiler
        ? routingConfiguration === 'Current'
            ? t('CURRENT')
            : routingConfiguration.replace(/^\D+/g, '')
        : null;
    return (React.createElement(DescriptionListItem, { dataTestId: "order-distance", label: t('TOTAL_DISTANCE'), className: "mt-2" },
        React.createElement(DistanceUnitFormatter, { fromUnit: fromUnit, toUnit: toUnit, distance: distance }),
        ' ',
        "(",
        t('ROUTING'),
        ": ",
        routerName,
        isPcMiler && (React.createElement(React.Fragment, null,
            ", ",
            t('VERSION'),
            ": ",
            versionLabel)),
        ")"));
};
